// extracted by mini-css-extract-plugin
export default {"primary-button":"PrimaryButton_primary-button__pv-Z7"};